/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AndamentoMeseDtoFromJSON, AndamentoMeseDtoToJSON, } from './AndamentoMeseDto';
import { ClienteCountDtoFromJSON, ClienteCountDtoToJSON, } from './ClienteCountDto';
import { ModalitaContattoCountDtoFromJSON, ModalitaContattoCountDtoToJSON, } from './ModalitaContattoCountDto';
import { ProssimaAttivitaPerClienteDtoFromJSON, ProssimaAttivitaPerClienteDtoToJSON, } from './ProssimaAttivitaPerClienteDto';
/**
 * Check if a given object implements the AgendaCommercialeDashboardDto interface.
 */
export function instanceOfAgendaCommercialeDashboardDto(value) {
    return true;
}
export function AgendaCommercialeDashboardDtoFromJSON(json) {
    return AgendaCommercialeDashboardDtoFromJSONTyped(json, false);
}
export function AgendaCommercialeDashboardDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'azioniTotali': json['azioniTotali'] == null ? undefined : json['azioniTotali'],
        'azioniUltimaSettimana': json['azioniUltimaSettimana'] == null ? undefined : json['azioniUltimaSettimana'],
        'azioniMeseCorrente': json['azioniMeseCorrente'] == null ? undefined : json['azioniMeseCorrente'],
        'clientiPiuContattati': json['clientiPiuContattati'] == null ? undefined : (json['clientiPiuContattati'].map(ClienteCountDtoFromJSON)),
        'clientiNonContattati': json['clientiNonContattati'] == null ? undefined : (json['clientiNonContattati'].map(ClienteCountDtoFromJSON)),
        'attivitaPerModalita': json['attivitaPerModalita'] == null ? undefined : (json['attivitaPerModalita'].map(ModalitaContattoCountDtoFromJSON)),
        'andamentoAttivita': json['andamentoAttivita'] == null ? undefined : (json['andamentoAttivita'].map(AndamentoMeseDtoFromJSON)),
        'prossimeAttivitaPerCliente': json['prossimeAttivitaPerCliente'] == null ? undefined : (json['prossimeAttivitaPerCliente'].map(ProssimaAttivitaPerClienteDtoFromJSON)),
    };
}
export function AgendaCommercialeDashboardDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'azioniTotali': value['azioniTotali'],
        'azioniUltimaSettimana': value['azioniUltimaSettimana'],
        'azioniMeseCorrente': value['azioniMeseCorrente'],
        'clientiPiuContattati': value['clientiPiuContattati'] == null ? undefined : (value['clientiPiuContattati'].map(ClienteCountDtoToJSON)),
        'clientiNonContattati': value['clientiNonContattati'] == null ? undefined : (value['clientiNonContattati'].map(ClienteCountDtoToJSON)),
        'attivitaPerModalita': value['attivitaPerModalita'] == null ? undefined : (value['attivitaPerModalita'].map(ModalitaContattoCountDtoToJSON)),
        'andamentoAttivita': value['andamentoAttivita'] == null ? undefined : (value['andamentoAttivita'].map(AndamentoMeseDtoToJSON)),
        'prossimeAttivitaPerCliente': value['prossimeAttivitaPerCliente'] == null ? undefined : (value['prossimeAttivitaPerCliente'].map(ProssimaAttivitaPerClienteDtoToJSON)),
    };
}
